import PurchaseTicket from "./index";
import useNavigateWrapper from "../../../../shared/hooks/useNavigateWrapper";
import React from "react";
import { MyExpRoute } from "../../routes/types";
import { createSearchParams } from "react-router-dom";
import QueryParamKey from "../../../../shared/enums/QueryParamKey";
import { useAuth } from "../../../../shared/context/auth";

export default function PurchaseTicketWrapper() {
  const { navigate } = useNavigateWrapper();
  const { userDetail } = useAuth();
  const openAssignToMeTicketHandler = React.useCallback(() => {
    navigate({
      pathname: `/${MyExpRoute.TICKET_ASSIGN.path}`,
      search: createSearchParams({
        [QueryParamKey.REG_PARTICIPATION_ID]: userDetail?.id as string,
        [QueryParamKey.EMAIL_ID]: userDetail?.email as string,
        [QueryParamKey.STEP_NUMBER]: "1"
      }).toString()
    });
  }, [navigate, userDetail?.email, userDetail?.id]);

  return (
    <PurchaseTicket
      dismissPurchaseTicketHandler={() => navigate(MyExpRoute.HOME.path)}
      openAssignTicketToSelfHandler={openAssignToMeTicketHandler}
    />
  );
}
